module.exports = __webpack_public_path__ + "fa1851dcf194bc2343135daf5643044b.MP3";